import styled from 'styled-components';

export const Card = styled.div`
  cursor: grab;
  color: white;
  position: relative;
  height: 42rem;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  @media (${({ theme }) => theme.respondTo.tablet}) {
    height: 50rem;
  }
  &:nth-child(odd) {
    border-top-right-radius: 10rem;
  }
  &:nth-child(even) {
    border-bottom-left-radius: 10rem;
  }

  a {
    position: absolute;
    bottom: 0;
    right: 0;
  }
`;
export const ImageWrapper = styled.div`
  ::after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.159) 30.73%,
      rgba(0, 0, 0, 0.3) 48.96%,
      rgba(0, 0, 0, 0.159) 86.98%
    );
    pointer-events: none;
  }
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  > div {
    height: 100%;
  }
`;

export const Title = styled.h3`
  font-size: 2.1rem;
  line-height: 125%;
  font-family: var(--font-tertiary);
  @media (${({ theme }) => theme.respondTo.desktop}) {
    font-size: 2.5rem;
  }
`;

export const Subtitle = styled.p`
  font-size: 1.6rem;
  margin-top: 1rem;
`;

export const InfoWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  padding: 4rem 7rem 0 4rem;
  @media (${({ theme }) => theme.respondTo.desktop}) {
    padding: 5rem 9rem 0 4rem;
  }
`;
